module.exports = __webpack_public_path__ + "static/media/bool.c2b02e48.glb";